import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonSelectFieldWidget } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { VolunteerSignupMentorDetails } from '@interfaces';
import { FuncService } from '../../../../services';
import { MentorSignUpAddFields, MentorSignupAddForm } from './mentor-sign-up-add.form';

export interface MentorSignUpAddDialogData {
	volunteerId: number,
	canVolunteerInEnglish: boolean,
	canVolunteerInSpanish: boolean
}

@Component({
	selector: 'programs-mentor-sign-up-add-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonSelectFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentor-sign-up-add.dialog.html'
})

export class MentorSignUpAddDialog implements OnInit, AfterViewInit {

	public dialogRef = inject(MatDialogRef<MentorSignUpAddDialog>);
	public dialogContext: DialogContext<VolunteerSignupMentorDetails> = inject(MAT_DIALOG_DATA);
	private func = inject(FuncService);

	public form = new MentorSignupAddForm();
	public formSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('formSaveBtn');

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			this.form.volunteerData.set({ canVolunteerInEnglish: data.canVolunteerInEnglish, canVolunteerInSpanish: data.canVolunteerInSpanish });
		}
	}

	ngAfterViewInit(): void {
		this.form.commonForm.setSubmitButton(
			this.formSaveBtn(),
			async (values: MentorSignUpAddFields, changed: string[]) => {

				if (!this.dialogContext.data) return;

				await this.func.volunteer.signup.mentor.add({
					volunteerId: this.dialogContext.data.volunteerId,
					trimesterId: values.trimesterId,
					selectedLanguage: values.selectedLanguage
				});

				this.dialogRef.close();
			}
		);
	}

	revertValues() {
		this.form.commonForm.resetAll();
	}
}